import React from "react";

import { findAdditionalInfo, findUpdateKey } from "components/attributes/compare-table/field-builder";

const RootField = ({ attribute, defaultValue, updateVarietyAttribute, Field, varietyId, readOnly }) => {
    const updateField = (name, value) => {
        updateVarietyAttribute(attribute, value, varietyId);
    };

    const updateOn = { [findUpdateKey(attribute.componentType)]: updateField };

    return (
        <Field
            key={`field_${attribute.uuid}`}
            id={`${attribute.uuid}`}
            name={`${attribute.uuid}`}
            validation={attribute.validation}
            hint={attribute.tooltip}
            required={attribute.required}
            dataType={attribute.componentType}
            defaultValue={defaultValue}
            attribute={attribute}
            disabled={readOnly}
            //codingWipKey={codingWipKey}
            //photoWipKey={photoWipKey}
            lockable={attribute.lockable}
            {...updateOn}
            {...findAdditionalInfo(attribute.componentType, attribute.additionalInfo)}
            skipInternalSave={true}
        />
    );
};

export default React.memo(RootField);
